<!-- @format -->

<template>
	<div :class="isHeight ? 'calendar calendarHeightMax' : 'calendar'">
		<el-calendar
			ref="calendar"
			v-model="calendarValue"
			:class="calendarHeight ? 'work-img-border calendarHeight' : 'work-img-border'"
			style="background-color: var(--theme-workbench-bg-color); padding: 20px"
			@click="clickCalendar"
		>
			<template #dateCell="{ data }">
				<sapn v-if="new Date().toDateString() === new Date(data.day).toDateString()" class="calendarDate">
					<span class="todayDate"> 今 </span>
				</sapn>
				<sapn v-else class="calendarDate">
					<span class="otherDate">
						{{ data.day.split('-').slice(2).join('-') }}
					</span>
				</sapn>
				<el-popover placement="bottom-start" :width="420" trigger="hover" popper-class="scrollable-popover">
					<div style="max-height: 200px; overflow-y: auto; box-sizing: border-box; font-size: 12px">
						<div
							v-for="item in monthData[`${data.day}`] && monthData[`${data.day}`].length
								? monthData[`${data.day}`]
								: []"
							:key="item.taskId"
							class="messageList"
							@click="clickToWork(item)"
						>
							<span class="messageName" :title="item.baseSummary">
								{{ item.baseSummary }}
							</span>
							<span :title="item.modelName" class="messageType">{{ item.modelName }}</span>
							<span :class="item.closed ? 'overMessageState' : 'messageState'">{{ item.ticketStatus }}</span>
						</div>
					</div>
					<template #reference>
						<span
							v-if="monthData[`${data.day}`] && monthData[`${data.day}`].length && !isWorkbenchedit"
							class="dateNews"
						>
							{{ monthData[`${data.day}`].length }}
						</span>
					</template>
				</el-popover>
				<el-popover placement="bottom-start" :width="420" trigger="hover" popper-class="scrollable-popover">
					<div style="max-height: 200px; overflow-y: auto; box-sizing: border-box; font-size: 12px">
						<div
							v-for="item in monthTodoData[`${data.day}`] && monthTodoData[`${data.day}`].length
								? monthTodoData[`${data.day}`]
								: []"
							:key="item.taskId"
							class="messageList"
							@click="clickToWork(item)"
						>
							<span class="messageName" :title="item.baseSummary">
								{{ item.baseSummary }}
							</span>
							<span class="messageType">{{ item.modelName }}</span>
							<span :class="item.closed ? 'overMessageState' : 'messageState'">{{ item.ticketStatus }}</span>
						</div>
					</div>
					<template #reference>
						<span
							v-if="monthTodoData[`${data.day}`] && monthTodoData[`${data.day}`].length && !isWorkbenchedit"
							class="dateNews todoNews"
						>
							{{ monthTodoData[`${data.day}`].length }}
						</span>
					</template>
				</el-popover>
			</template>
			<template #header="{ date }">
				<span class="calendarName">
					工作日历
					<span v-if="!isWorkbenchedit" class="arrowIconName"></span>
				</span>
				<span v-if="!isWorkbenchedit" class="calendarMonth">
					{{ date }}
				</span>

				<span class="calendarHeader">
					<el-popover placement="bottom" :width="100" trigger="hover">
						<div style="text-align: center"> 我发起的工单 </div>
						<template #reference>
							<span class="dateNews">
								{{ '创' }}
							</span>
						</template>
					</el-popover>
					<el-popover placement="bottom" :width="100" trigger="hover">
						<div style="text-align: center"> 我待办的工单 </div>
						<template #reference>
							<span class="dateNews todoNews">
								{{ '待' }}
							</span>
						</template>
					</el-popover>
					<!-- <el-tooltip
						:visible-arrow="false"
						placement="bottom-start"
						class="tooltipName"
						popper-class="calendarTooltip"
					>
						<template #content>
							<div class="messageList"> 我待办的工单 </div>
						</template>
						<span class="dateNews todoNews">
							{{ '待' }}
						</span>
					</el-tooltip> -->

					<el-button-group class="calendarButton">
						<el-button size="small" @click="selectDate('prev-month')"> 上月 </el-button>
						<el-button size="small" @click="selectDate('today')"> 今天 </el-button>
						<el-button size="small" @click="selectDate('next-month')"> 下月 </el-button>
					</el-button-group>
				</span>
			</template>
		</el-calendar>
	</div>
	<!-- 对话框 -->
	<el-dialog
		v-model="dialogVisible"
		:close-on-click-modal="false"
		append-to-body
		title="工单列表"
		width="50%"
		:before-close="dialogCancel"
		custom-class="calendarDialog"
	>
		<el-transfer
			v-model="transferValue"
			:titles="['未选择类型', '已选择类型']"
			target-order="push"
			:data="transferData"
			@change="transferChange"
		>
		</el-transfer>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="dialogCancel">取消</el-button>
				<el-button type="primary" @click="dialogDetermine">确定</el-button>
			</span>
		</template>
	</el-dialog>
	<div v-show="isWorkbenchedit" class="delEdit">
		<el-icon style="margin-right: 10px" @click="settingIcon"><icon-ant-design:setting-outlined /></el-icon>
		<el-icon @click="delEdit"><icon-ant-design:delete-outlined /></el-icon>
	</div>
</template>

<script setup name="calendar">
	import { ref } from 'vue';
	import { onBeforeRouteLeave } from 'vue-router';
	import { getEnvUrlByUrl } from '@power/runtime-vue3';
	import { openWindow } from '@power/utils';
	import { getCalendarList, openTicketInfo, workflowTypes } from '@/api/powercess/workbench';

	const emit = defineEmits(['deletePanelItemEvent', 'selectItemEvent']);
	const props = defineProps({
		isHeight: {
			type: [Boolean],
		},
		isWorkbenchedit: {
			type: [Boolean],
		},
		id: {
			type: [Number, String],
		},
		editArray: {
			type: [Array],
		},
	});

	const calendar = ref();

	// 双向绑定日历展示的日期
	const calendarValue = ref();

	// 控制模态框显隐
	const dialogVisible = ref(false);
	// 穿梭框中选中的值
	const transferValue = ref(props.editArray && props.editArray.length ? props.editArray : []);
	// 穿梭框的列表
	const workTypeList = ref([]);
	// 穿梭框的数据
	const transferData = ref(generateData());

	// 选择的年份
	const valueYear = ref();

	// 选择的年份
	const valueMonth = ref();

	// 判断日历内容是5行还是6行
	const calendarHeight = ref(false);

	// 表格是否加载
	const loading = ref(true);

	// 每月的数据
	const monthData = ref({});

	// 每月的待办数据
	const monthTodoData = ref({});

	// 当前渲染的数据的月份
	const currentMonth = ref();

	// 根据穿梭框的选择动态渲染展示的数据
	const serviceList = ref(props.editArray && props.editArray.length ? props.editArray : []);

	// 穿梭框显示
	function settingIcon() {
		dialogVisible.value = true;
	}
	// 穿梭框数据的变化
	function transferChange(rightList) {
		transferValue.value = rightList;
	}
	// 渲染要展示穿梭框的数据
	function generateData() {
		const data = [];
		for (let i = 0; i < workTypeList.value.length; i++) {
			data.push({
				key: workTypeList.value[i].code,
				label: workTypeList.value[i].name,
				disabled: workTypeList.value[i].disabled,
			});
		}
		return data;
	}
	// 对话框确定按钮
	function dialogDetermine() {
		const data = [];
		for (let i = 0; i < workTypeList.value.length; i++) {
			for (let j = 0; j < transferValue.value.length; j++) {
				if (transferValue.value[j] === workTypeList.value[i].code) {
					data.push(workTypeList.value[i].code);
				}
			}
		}
		transferValue.value = data;
		serviceList.value = data;
		const selectItemEvent = {
			selectList: transferValue.value,
			// module: '工作日历',
			module: props.id,
		};
		emit('selectItemEvent', selectItemEvent);
		dialogVisible.value = false;
	}
	// 对话框取消按钮
	function dialogCancel() {
		transferValue.value = serviceList.value;
		dialogVisible.value = false;
	}

	function delEdit() {
		emit('deletePanelItemEvent', props.id);
	}

	function selectDate(val) {
		calendar.value.selectDate(val);
	}

	onMounted(() => {
		setCalendarHeight();
	});

	function setCalendarHeight() {
		if (document.getElementsByClassName('el-calendar-table__row').length < 6) {
			calendarHeight.value = true;
		} else {
			calendarHeight.value = false;
		}
	}

	// 第一次渲染本月工单
	function onceMonthData() {
		const date = new Date();
		calendarValue.value = date;
		// 年
		const year = date.getFullYear();
		// 去0前缀的月份
		const dateRangeMonth = date.getMonth() + 1;
		valueYear.value = year;
		valueMonth.value = dateRangeMonth;
		// 类型列表
		workflowTypes({ permissionType: 'QUERY' }).then((res) => {
			const data = res.data.map((item) => ({
				...item,
				disabled: false,
			}));
			workTypeList.value = data;
			transferData.value = generateData();
			getDateRange(year, dateRangeMonth);
		});
	}

	// 日历变化时时间
	function clickCalendar() {
		const date = new Date(calendar.value.selectedDay);
		// 年
		const year = date.getFullYear();
		// 去0前缀的月份
		const dateRangeMonth = date.getMonth() + 1;
		valueYear.value = year;
		valueMonth.value = dateRangeMonth;
		if (currentMonth.value !== dateRangeMonth && loading.value === false) {
			getDateRange(year, dateRangeMonth);
		}
	}

	// 获得当月时间
	function getDateRange(year, month) {
		setCalendarHeight();
		const days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		if (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) {
			days[1] = 29;
		}
		loading.value = true;
		const havedList = [];
		for (let i = 0; i < workTypeList.value.length; i++) {
			for (let j = 0; j < transferValue.value.length; j++) {
				if (workTypeList.value[i].code == transferValue.value[j]) {
					havedList.push(workTypeList.value[i].code);
				}
			}
		}
		const typeList = trimSpace(havedList);
		getCalendarList({
			endDate: `${year}-${month}-${days[month - 1]}`,
			startDate: `${year}-${month}-1`,
			modelCodes: typeList.toString(),
		}).then((res) => {
			loading.value = false;
			if (res.data.created) {
				monthData.value = res.data.created;
			}
			if (res.data.todo) {
				monthTodoData.value = res.data.todo;
			}
			currentMonth.value = month;
			setCalendarHeight();
		});
	}
	// 数组中的空值去掉
	function trimSpace(array) {
		for (let i = 0; i < array.length; i++) {
			if (array[i] == '' || array[i] == null || typeof array[i] == 'undefined') {
				array.splice(i, 1);
				i = i - 1;
			}
		}
		return array;
	}

	// 点击每一项跳转到工单详情
	function clickToWork(info) {
		const { ticketId, modelCode, taskId } = info;
		openTicketInfo({
			ticketId,
			modelCode,
			taskId,
		}).then((res) => {
			const url = getEnvUrlByUrl(res.data);
			openWindow(url);
		});
	}

	// 定时请求工单
	const timeMessage = window.setInterval(() => {
		setTimeout(() => {
			if (loading.value === false) {
				getDateRange(valueYear.value, valueMonth.value);
			}
		}, 0);
	}, 20000);
	onBeforeRouteLeave(() => {
		window.clearInterval(timeMessage);
	});

	onceMonthData();
</script>
<style>
	body .el-popover.scrollable-popover {
		border-radius: 10px !important;
	}
</style>
<style scoped lang="scss">
	// @import '@/assets/styles/base/base-variables.module.scss';

	.delEdit {
		position: absolute;
		top: 20px;
		right: 25px;
		// font-size: $app-fontsize-title;
		z-index: 999;

		.el-icon {
			// color: $theme-workbench-icon-color;
			cursor: pointer;
		}
	}

	.calendar {
		height: 100%;
		padding: 12px 0px 0 12px;

		:deep .el-calendar {
			--el-calendar-cell-width: 59px;
			--el-calendar-border: 1px solid var(--theme-workbench-calendar-border-color);
			--el-calendar-selected-bg-color: var(--theme-workbench-calendar-el-calendar-selected-bg-color);
			height: 100%;
			background-color: var(--theme-bg-color);

			// color: $theme-workbench-calendar-color;
			padding: 0 9px;
			font-size: 18px;

			.el-calendar__header {
				height: 35px;
				line-height: 35px;
				margin-top: -4.94px;
				border: none;
				padding: 0;

				.calendarName {
					display: inline-block;
					min-width: 33.3%;
					// font-size: $app-fontsize-title;
					font-weight: 600;
					// color: $theme-workbench-title-color;
					opacity: 0.9;

					.arrowIconName {
						vertical-align: middle;
						display: inline-block;
						width: 164px;
						height: 16px;
						background-size: contain;
						margin-left: 10px;
					}
				}

				.calendarHeader {
					display: inline-block;
					width: 33.3%;
					text-align: right;

					.calendarButton {
						.el-button {
							background: none;
							border: none;
							color: #000;
							padding: 0;
							width: 60px;
							height: 25px;
							line-height: 25px;
							// font-size: $app-fontsize-medium;
						}

						.el-button:focus {
							border-bottom: 2px solid var(--theme-workbench-calendar-border-color);
						}
					}

					.datePicker {
						display: inline-block;
						width: 70px;

						.el-input__wrapper {
							display: inline-block;
							background: none;

							.el-input__prefix {
								display: none;
							}

							.el-input__inner {
								flex-grow: 0;
								display: inline-block;
								color: #c8f1ff;
								text-align: center;
							}
						}
					}
				}
			}

			.el-calendar__body {
				padding: 10px 0;

				.el-calendar-table {
					border: 1px solid var(--theme-workbench-calendar-border-color);

					thead {
						th {
							padding: 0;
							color: var(--theme-workbench-title-color);
							font-weight: 400;
							border-bottom: 1px solid var(--theme-workbench-calendar-border-color);
						}

						.el-calendar-day {
							padding: 0 0;
							height: 100%;
						}
					}

					.el-calendar-table td.is-selected {
						// background: $theme-workbench-calendar-border-color;
					}
				}
			}
		}

		.calendarHeight {
			--el-calendar-cell-width: 71px;
		}

		.calendarDate {
			display: block;
			text-align: right;
			height: 50%;
		}

		.todayDate {
			color: #fff;
			display: inline-block;
			height: 25px;
			width: 25px;
			text-align: center;
			background: #57cabb;
			border-radius: 50%;
			line-height: 25px;
			font-size: 16px;
		}

		.todayDate1 {
			color: #fff;
			display: inline-block;
			height: 25px;
			width: 25px;
			text-align: center;
			background: #57cabb;
			border-radius: 50%;
			line-height: 25px;
			font-size: 10px;
			margin-left: 10px;
		}

		.todayDate2 {
			color: #fff;
			display: inline-block;
			height: 25px;
			width: 25px;
			text-align: center;
			background: #259fe9;
			border-radius: 50%;
			line-height: 25px;
			font-size: 10px;
		}

		.dateNews {
			color: #fff;
			display: inline-block;
			font-size: 12px;
			text-align: center;
			background: #259fe9;
			border-radius: 50%;
			line-height: 21px;
			padding: 0 0.4em;
			margin-right: 5px;
		}

		.todoNews {
			background: #57cabb;
		}

		:deep .el-popper.is-dark {
			background: none;
			color: none;
		}
	}

	.calendarHeightMax {
		padding: 0;

		:deep .el-calendar {
			.el-calendar__header {
				height: 33px;
				line-height: 250%;

				.calendarMonth {
					font-size: 1.6rem;
				}
			}

			.el-calendar__body {
				height: 94%;

				.el-calendar-table {
					height: 100%;

					.el-calendar-table__row {
						height: 14.2% !important;

						.el-calendar-day {
							padding: 0.5rem;
							height: 100%;
						}
					}
				}
			}

			.todayDate {
				height: 2.5rem;
				width: 2.5rem;
				line-height: 2.5rem;
				font-size: 1.6rem;
			}

			.otherDate {
				display: inline-block;
				height: 2.5rem;
				width: 2.5rem;
				text-align: center;
				line-height: 2.5rem;
				font-size: 1.6rem;
			}

			.dateNews {
				font-size: 1rem;
				min-height: 2rem;
				min-width: 2rem;
				line-height: 2rem;
				padding: 0 0.4rem;
			}

			.dateNews2 {
				display: inline-block;
				height: 2rem;
				width: 2rem;
				text-align: center;
				line-height: 2rem;
				padding: 0 0.4rem;
			}
		}

		.calendarHeight {
			:deep .el-calendar__body {
				height: 94%;

				.el-calendar-table {
					height: 100%;

					.el-calendar-table__row {
						height: 20% !important;

						.el-calendar-day {
							height: 100%;
							padding-bottom: 0.5rem;
							padding-top: 0.5rem;
						}
					}
				}
			}
		}

		.calendarDate {
			height: 60%;
		}
	}
</style>
<style lang="scss">
	// @import '@/assets/styles/base/base-variables.module.scss';

	.monthPicker {
		.el-date-picker__header {
			display: none;
		}
	}

	.messageList {
		color: #000;
		height: 38px;
		line-height: 38px;
		padding: 0 15px;
		// font-size: $app-fontsize-medium;
		cursor: pointer;

		.messageState {
			display: inline-block;
			margin-left: 16px;
			color: var(--theme-color-warning-light-3);
			vertical-align: top;
		}

		.overMessageState {
			display: inline-block;
			margin-left: 16px;
			color: var(--theme-color-primary-light-3);
			vertical-align: top;
		}

		.messageType {
			display: inline-block;
			margin-left: 16px;
			vertical-align: top;
			width: 100px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.messageName {
			display: inline-block;
			width: 130px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			vertical-align: top;
		}
	}
	// 日历的文字提示
	// .calendarTooltip {
	// 	max-height: 210px;
	// 	background: #fafafc !important;
	// 	border: none;
	// 	overflow: auto;

	// .messageList {
	// 	color: #000;
	// 	height: 38px;
	// 	line-height: 38px;
	// 	padding: 0 15px;
	// 	// font-size: $app-fontsize-medium;
	// 	cursor: pointer;

	// 	.messageState {
	// 		display: inline-block;
	// 		margin-left: 19px;
	// 		color: #fee335;
	// 		vertical-align: top;
	// 	}

	// 	.overMessageState {
	// 		display: inline-block;
	// 		margin-left: 19px;
	// 		color: #57f3de;
	// 		vertical-align: top;
	// 	}

	// 	.messageType {
	// 		display: inline-block;
	// 		margin-left: 19px;
	// 		vertical-align: top;
	// 	}

	// 	.messageName {
	// 		display: inline-block;
	// 		width: 130px;
	// 		white-space: nowrap;
	// 		overflow: hidden;
	// 		text-overflow: ellipsis;
	// 		vertical-align: top;
	// 	}
	// }

	// .el-popper__arrow {
	// 	display: none;
	// }
	// }
</style>
<style lang="scss">
	.calendarDialog {
		.el-transfer {
			text-align: center;
		}
	}
</style>
